<!--
 Copyright 2024 Google LLC.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<div>
  <mat-tab-group color="accent">
    <mat-tab label="{{testGroup}}" *ngFor="let testGroup of testGroups; index as i">
      <app-mape-and-impact-summary-card
        [cardTitle]="'Causal Impact Report'"
        [mape]="causalImpactResults.causal_impact_mapes[i]"
        [rawCausalImpactSummary]="causalImpactResults.causal_impact_summaries[i]"/>
      <div class="view-result-entry">
        <h2 [matTooltip]="helpMessagesService.causalImpactResultsPage.CARD_CAUSAL_IMPACT_GRAPHS"
          matTooltipClass="multi-line-tooltip max-width-tooltip" i18n>Causal Impact Graphs</h2>
        <app-vega-chart [spec]="causalImpactGraphs[i]"/>
      </div>
      <div *ngIf="causalImpactResults.causal_impact_covariate_weights
        && causalImpactResults.causal_impact_covariate_weights[i].length > 2"
        class="view-result-entry">
        <h2>Causal Impact Covariate Weights (Inclusion Probability)</h2>
        <app-vega-chart [spec]="covariateWeightsGraphs[i]"></app-vega-chart>
      </div>
    </mat-tab>
  </mat-tab-group>
  <app-routing-button class="left-button" [buttonLabel]="'Rerun'" *ngIf="!isCovariatesAnalysis"
    [matTooltip]="helpMessagesService.experimentCommonInputFields.BUTTON_RERUN"
    matTooltipClass="max-width-tooltip"
    [forceTransitionToContinueImpactMeasurement]="true"
    [experimentId]="experimentId" [action]="sendImpactMeasurementAction()"/>
</div>
